module.exports = __webpack_public_path__ + "media/images/subcity-icon-white-d6a96ad3e78c9f72ca7dc89adaca8f17.png";